import { useQuery } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const fetchWithdrawalRules = async ({
  show_deleted = false,
  show_inactive = true,
  limit,
}) => {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const payload = { show_deleted, show_inactive };
  if (limit) payload.limit = limit;

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_WITHDRAWAL_RULES,
    payload
  );

  return response?.data?.data ?? [];
};

export const useGetWithdrawalRules = (
  show_deleted = false,
  show_inactive = true,
  limit
) => {
  return useQuery({
    queryKey: ['GET_WITHDRAWAL_RULES', show_deleted, show_inactive, limit],
    queryFn: () => fetchWithdrawalRules({ show_deleted, show_inactive, limit }),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
